import React, { useMemo } from "react";
import { FormComponent } from "./html/FormComponent";
import { useParams, useLocation, Link } from "react-router-dom";

const styles = {
  wrapper: {
    backgroundColor: "white", // Rojo similar a la imagen
    color: "black",
    padding: "10px",
    borderRadius: "12px",
    maxWidth: "400px",
    textAlign: "center",
    fontFamily: "sans-serif",
    margin: "0px auto",
  },
  title: {
    fontWeight: "bold",
    fontSize: "15px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "13px",
    lineHeight: "20px",
  },
  button: {
    backgroundColor: "#D81317",
    color: "white",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export const SurveyComponent = ({
  nameEncuesta,
  guidIdEncuesta,
  isEncuestaGenerica,
}) => {
  const { pNameEncuesta, pGuidIdEncuesta } = useParams();
  const location = useLocation();
  const guidActivarBotonInicio = process.env.REACT_APP_ACTIVAR_BOTON_INICIO;

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const uploadSurvey = searchParams.get("uploadSurvey");

  const finalNameEncuesta = nameEncuesta || pNameEncuesta;
  const finalGuidIdEncuesta = guidIdEncuesta || pGuidIdEncuesta;

  // Armamos el link con uploadSurvey=yes manteniendo los params
  searchParams.set("uploadSurvey", "yes");
  const newSearch = searchParams.toString();
  const linkToEnableUpload = `${location.pathname}?${newSearch}`;

  return (
    <div className="container">
      <div className="containerSurvey">
        {finalGuidIdEncuesta !== guidActivarBotonInicio ||
        uploadSurvey === "yes" ? (
          <FormComponent
            nameEncuesta={finalNameEncuesta}
            guidIdEncuesta={finalGuidIdEncuesta}
            isEncuestaGenerica={isEncuestaGenerica}
          />
        ) : (
          <div>
            <div style={styles.wrapper}>
              <h3 style={styles.title}>Queremos conocer tu opinión</h3>
              <p style={styles.text}>
                Ayudanos a mejorar tu experiencia respondiendo esta breve
                encuesta. Solo te tomará unos segundos.
              </p>

              <Link to={linkToEnableUpload}>
                <button style={styles.button} className="btn btn-primary">
                  Responder encuesta
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

/*
import React from "react";
import { FormComponent } from "./html/FormComponent";
import { useParams } from "react-router-dom";

export const SurveyComponent = ({
  nameEncuesta,
  guidIdEncuesta,
  isEncuestaGenerica,
}) => {
  const { pNameEncuesta, pGuidIdEncuesta } = useParams();
  return (
    <div className="container">
      <div className="containerSurvey">
        <FormComponent
          nameEncuesta={nameEncuesta ? nameEncuesta : pNameEncuesta}
          guidIdEncuesta={guidIdEncuesta ? guidIdEncuesta : pGuidIdEncuesta}
          isEncuestaGenerica={isEncuestaGenerica}
        />
      </div>
    </div>
  );
};
*/
